import { Carrier, CARRIER_SLUG_TO_CARRIER } from "./carriers.js";
/**
 * Carriers Paul contracts by sending the agent an invite from Altura's own
 * login on the carrier's portal (Oct 28 call). Not SureLC, not an IMO form.
 */
export const DIRECT_INVITE_CARRIERS = [Carrier.AFLAC, Carrier.AMERICAN_HOME_LIFE];
export function isDirectInviteCarrier(value) {
    return DIRECT_INVITE_CARRIERS.includes(value);
}
/** Direct-invite carriers among a submission's carrier slugs, in catalog order. */
export function directInviteCarriersFor(carrierValues) {
    const selected = new Set(carrierValues.map((value) => CARRIER_SLUG_TO_CARRIER[value]));
    return DIRECT_INVITE_CARRIERS.filter((carrier) => selected.has(carrier));
}
